import { render, staticRenderFns } from "./selectSubsidiary2.vue?vue&type=template&id=67ddb800&scoped=true"
import script from "./selectSubsidiary2.vue?vue&type=script&lang=js"
export * from "./selectSubsidiary2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ddb800",
  null
  
)

export default component.exports